// icons.service.ts
import {Injectable} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable({providedIn: 'root'})
export class IconsService {
	constructor(
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer
	) {}

	public registerIcons(): void {
		this.loadIcons(
			['autoplay', 'assets/img/icons/autoplay.svg'],
			['check', 'assets/img/icons/checkmark.svg'],
			['checkmark', 'assets/img/icons/checkmark.svg'],
			['empty-folder', 'assets/img/icons/empty-folder.svg'],
			['error', 'assets/img/icons/error.svg'],
			['flag-de', 'assets/img/icons/flag-de.svg'],
			['flag-en', 'assets/img/icons/flag-en.svg'],
			['flag-es', 'assets/img/icons/flag-es.svg'],
			['flag-fr', 'assets/img/icons/flag-fr.svg'],
			['flag-it', 'assets/img/icons/flag-it.svg'],
			['flag-ja', 'assets/img/icons/flag-ja.svg'],
			['flag-pt', 'assets/img/icons/flag-pt.svg'],
			['flag-ru', 'assets/img/icons/flag-ru.svg'],
			['flag-zh', 'assets/img/icons/flag-zh.svg'],
			['fluid', 'assets/img/icons/fluid.svg'],
			['folder-error', 'assets/img/icons/folder-error.svg'],
			['gain', 'assets/img/icons/gain.svg'],
			['google', 'assets/img/icons/google.svg'],
			['info', 'assets/img/icons/info.svg'],
			['key', 'assets/img/icons/key.svg'],
			['log-error', 'assets/img/icons/log-error.svg'],
			['logo-short', 'assets/img/icons/logo-short.svg'],
			['logo', 'assets/img/icons/logo.svg'],
			['loop', 'assets/img/icons/loop.svg'],
			['magic-link', 'assets/img/icons/magic-link.svg'],
			['mobile', 'assets/img/icons/mobile.svg'],
			['mute', 'assets/img/icons/mute.svg'],
			['short_logo', 'assets/img/icons/short_logo.svg'],
			[
				'short_logo_with_transparent_background',
				'assets/img/icons/short_logo_with_transparent_background.svg',
			],
			[
				'short_logo_without_border',
				'assets/img/icons/short_logo_without_border.svg',
			],
			['warn', 'assets/img/icons/warn.svg'],
			['folder', 'assets/img/icons/folder.svg'],
			['folder-open', 'assets/img/icons/folder-open.svg'],
			['video', 'assets/img/icons/video.svg'],
			['pencil', 'assets/img/icons/pencil.svg'],
			['trash', 'assets/img/icons/trash.svg'],
			['list-bullet', 'assets/img/icons/list-bullet.svg']
		);
	}

	private loadIcons(...icons: [string, string][]): void {
		icons.forEach(([name, path]) => {
			this.matIconRegistry.addSvgIcon(
				name,
				this.domSanitizer.bypassSecurityTrustResourceUrl(path)
			);
		});
	}
}
